import React, { Component } from 'react';
import shortID from 'short-id-gen';
import InputColor from 'react-color';
import Modal from './Modal';
import { Button, InputGroup } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';

const initialState = {
  name: null,
  description: null,
  color: 'rgba(222,75,75,0.9)',
  slides: [],
  selectedNewSlide: null,
  createdAt: null,
  lastModified: null,
}

class PlaylistModal extends Modal {

  constructor(props) {
    super(props);

    this.state = { ...initialState }

    this.receivePlaylistListener = this.receivePlaylistListener.bind(this);
    this.onSortSlides = this.onSortSlides.bind(this);
    this.addSlide = this.addSlide.bind(this);
    this.removeSlide = this.removeSlide.bind(this);
    this.swapSlides = this.swapSlides.bind(this);

    this.title = "Neue Slide";
    this.iconName = "numbered-list";
    this.initialState = initialState;
  }

  onComponentWillMount() {
    if (this.props.playlistID && this.props.playlistID !== 'new') {
      this.props.database.ref(`playlists/${this.props.playlistID}`).on('value', this.receivePlaylistListener);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.playlistID !== this.props.playlistID) {
      this.setState(initialState);

      if (this.props.playlistID && this.props.playlistID !== 'new') {
        this.props.database.ref(`playlists/${this.props.playlistID}`).off('value', this.receivePlaylistListener);
      }
      if (newProps.playlistID && newProps.playlistID !== 'new') {
        this.props.database.ref(`playlists/${newProps.playlistID}`).on('value', this.receivePlaylistListener);
      }
    }
  }

  onComponentWillUnmount() {
    if (this.props.playlistID && this.props.playlistID !== 'new') {
      this.props.database.ref(`playlists/${this.props.playlistID}`).off('value', this.receivePlaylistListener);
    }
  }

  addSlide() {
    if (!this.state.selectedNewSlide || this.state.selectedNewSlide === '') {
      return;
    }
    const slides = this.state.slides.slice(0);
    slides.push(this.state.selectedNewSlide);
    this.setState({ slides, selectedNewSlide: '' });
  }

  save() {
    if (!this.state.name) {
      return;
    }

    let playlistID = this.props.playlistID;
    playlistID = !playlistID || playlistID === 'new' ? shortID.generate(10) : playlistID;

    this.props.database.ref(`playlists/${playlistID}`).set({
      customer: this.props.customerID,
      name: this.state.name,
      description: this.state.description,
      color: this.state.color,
      slides: this.state.slides,
      createdAt: this.state.createdAt || new Date(),
      lastModified: new Date(),
    });
    this.hide();
  }

  receivePlaylistListener(snap) {
    const playlist = snap.val();
    if (typeof playlist.slides === 'object') {
      const slides = [];
      for (let k in playlist.slides) {
        if (playlist.slides.hasOwnProperty(k)) slides.push(playlist.slides[k])
      } ;
      playlist.slides = slides;
    }
    this.setState(playlist);
  }

  removeSlide(i) {
    const slides = this.state.slides.slice(0);
    slides.splice(i, 1);
    this.setState({ slides });
  }

  swapSlides(i, j) {
    const slides = this.state.slides.slice(0);
    if (slides[i] && slides[j]) {
      const slideI = slides[i];
      slides[i] = slides[j];
      slides[j] = slideI;
      this.setState({ slides });
    }
  }

  renderSlideRows() {
    const slides = []
    this.state.slides.forEach((slideID, i) => {
      const slideData = this.props.slides[slideID];
      slides.push(
        <tr key={slideID+i}>
          <td>{slideData.name}</td>
          <td>{slideData.description}</td>
          <td>{slideData.template}</td>
          <td>
            <Button onClick={() => this.swapSlides(i, i - 1)}>Up</Button>
            <Button onClick={() => this.swapSlides(i, i + 1)}>Down</Button>
            <Button onClick={() => this.removeSlide(i)}>
              Delete
            </Button>
          </td>
        </tr>
      )
    });
    return slides;
  }

  onSortSlides(data) {
    console.log(data);
  }

  renderNewSlideOptions() {
    const options = [
      <option key="default" value="">Slide zum Hinzufügen wählen</option>
    ];
    for (let key in this.props.slides) {
      if (!this.props.slides.hasOwnProperty(key)) continue;
      options.push(
        <option key={key} value={key}>{this.props.slides[key].name}</option>
      )
    }
    return options;
  }

  renderBody() {
    return (
      <Row>
        <Col sm={6}>
          <label>
            Name
            <InputGroup
              type="text"
              value={this.state.name || ''}
              placeholder={this.state.name ? null : 'Name der Playlist'}
              onChange={(e) => this.setState({ name: e.target.value })}
            />
          </label>
        </Col>
        <Col sm={6}>
          <label>
            Beschreibung
            <InputGroup
              type="text"
              value={this.state.description || ''}
              placeholder="Beschreibung der Playlist"
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </label>
        </Col>
        <Col sm={6}>
          <label>
            Farbe
            <InputColor
              color={this.state.color}
              onChange={(color) => this.setState({ color: `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})` })}
            />
          </label>
        </Col>
        <Col sm={12}>
          <h4>Slides</h4>
          <div className="pt-select">
            <select
              componentClass="select"
              placeholder="select"
              value={this.state.selectedNewSlide || ''}
              onChange={(e) => this.setState({ selectedNewSlide: e.target.value })}
            >
              {this.renderNewSlideOptions()}
            </select>
          </div>
          <Button onClick={this.addSlide}>Slide hinzufügen</Button>
          <table className="pt-table pt-bordered">
            <caption>Slides</caption>
            <thead>
              <tr>
                <th>Name</th>
                <th>Beschreibung</th>
                <th>Template</th>
                <th>Move</th>
              </tr>
            </thead>
            <tbody>
              {this.renderSlideRows()}
            </tbody>
          </table>
        </Col>
      </Row>
    );
  }
}

export default PlaylistModal;



/** WEBPACK FOOTER **
 ** ./src/modals/PlaylistModal.js
 **/